export default [
  {
    label: "ADMINISTRATOR",
    value: "admin",
  },
];
